// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as List from "@rescript/std/lib/es6/list.js";
import * as Util from "../../../common/util.bs.js";
import * as Button from "../../library/Button.bs.js";
import * as Caml_obj from "@rescript/std/lib/es6/caml_obj.js";
import * as CmsImage from "../../CmsImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var prodDomains = {
  hd: [
    "au",
    "https://www.prezzee.com.au"
  ],
  tl: {
    hd: [
      "ca",
      "https://www.prezzee.ca"
    ],
    tl: {
      hd: [
        "us",
        "https://www.prezzee.com"
      ],
      tl: {
        hd: [
          "uk",
          "https://www.prezzee.uk"
        ],
        tl: {
          hd: [
            "nz",
            "https://www.prezzee.co.nz"
          ],
          tl: /* [] */0
        }
      }
    }
  }
};

var stgDomains = {
  hd: [
    "au",
    "https://stg.prezzee.com.au"
  ],
  tl: {
    hd: [
      "ca",
      "https://stg.prezzee.ca"
    ],
    tl: {
      hd: [
        "us",
        "https://stg.prezzee.com"
      ],
      tl: {
        hd: [
          "uk",
          "https://stg.prezzee.uk"
        ],
        tl: {
          hd: [
            "nz",
            "https://stg.prezzee.co.nz"
          ],
          tl: /* [] */0
        }
      }
    }
  }
};

var isStg = process.env.NEXT_PUBLIC_PREZZEE_SERVER_URL.includes("stg");

function InternationalContentMobile(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(CmsImage.make, {
                            src: "/images/international/map_with_no_arrows.svg",
                            alt: "Prezzee International map",
                            width: 737,
                            height: 404,
                            className: "w-11/12 sm:w-9/12 mx-auto",
                            sizes: "(max-width: 640px) 82vw, 72vw"
                          }),
                      className: "my-16"
                    }),
                Caml_obj.equal(Util.EnvUtil.currentCountry, {
                      TAG: /* Ok */0,
                      _0: /* Australia */0
                    }) || Caml_obj.equal(Util.EnvUtil.currentCountry, {
                      TAG: /* Ok */0,
                      _0: /* NewZealand */3
                    }) ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("Introducing USA GIft Cards, now available on Prezzee! Send family and friends back home their favourite gift cards from top USA brands including Macy's, JC Penny and more.")
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: JsxRuntime.jsx("button", {
                                              children: Util.ReactStuff.s("Buy USA gift cards"),
                                              className: Cn.make([
                                                    Button.primaryStyle,
                                                    "h-12 w-56 mt-6"
                                                  ])
                                            }),
                                        href: isStg ? List.assoc("us", stgDomains) : List.assoc("us", prodDomains),
                                        target: "_blank"
                                      })
                                ],
                                className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("We're finally in Canada! Shop our ever expanding range of digital gift cards from leading Canadian brands such as Uber and Doordash.")
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: JsxRuntime.jsx("button", {
                                              children: Util.ReactStuff.s("Buy CA gift cards"),
                                              className: Cn.make([
                                                    Button.primaryStyle,
                                                    "h-12 w-56 mt-6"
                                                  ])
                                            }),
                                        href: isStg ? List.assoc("ca", stgDomains) : List.assoc("ca", prodDomains),
                                        target: "_blank"
                                      })
                                ],
                                className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("Make sending eGifts to the UK a breeze with Prezzee. Choose from top UK brands including John Lewis, Marks & Spencers and Debenhams. What could be easier!")
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: JsxRuntime.jsx("button", {
                                              children: Util.ReactStuff.s("Buy UK gift cards"),
                                              className: Cn.make([
                                                    Button.primaryStyle,
                                                    "h-12 w-56 mt-6"
                                                  ])
                                            }),
                                        href: isStg ? List.assoc("uk", stgDomains) : List.assoc("uk", prodDomains),
                                        target: "_blank"
                                      })
                                ],
                                className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("Check out the ever expanding range of eGift cards from hundreds of top brands, for everyone at home down under. Everything you need at your fingertips.")
                                      }),
                                  JsxRuntime.jsx("a", {
                                        children: JsxRuntime.jsx("button", {
                                              children: Util.ReactStuff.s("Buy Aussie gift cards"),
                                              className: Cn.make([
                                                    Button.primaryStyle,
                                                    "h-12 w-56 mt-6"
                                                  ])
                                            }),
                                        href: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                              TAG: /* Ok */0,
                                              _0: /* Australia */0
                                            }) ? "/store/" : (
                                            isStg ? List.assoc("au", stgDomains) : List.assoc("au", prodDomains)
                                          ),
                                        target: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                              TAG: /* Ok */0,
                                              _0: /* Australia */0
                                            }) ? "_self" : "_blank"
                                      })
                                ],
                                className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                              }),
                          Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                TAG: /* Ok */0,
                                _0: /* Australia */0
                              }) ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: Util.ReactStuff.s("Forget pigeon post across the Tasman, make Prezzee your one stop shop for sending eGift Cards to New Zealand. Favourite brands include Farmers, David Jones, JB HiFi and more.")
                                        }),
                                    JsxRuntime.jsx("a", {
                                          children: JsxRuntime.jsx("button", {
                                                children: Util.ReactStuff.s("Buy NZ gift cards"),
                                                className: Cn.make([
                                                      Button.primaryStyle,
                                                      "h-12 w-56 mt-6"
                                                    ])
                                              }),
                                          href: isStg ? List.assoc("nz", stgDomains) : List.assoc("nz", prodDomains),
                                          target: "_blank"
                                        })
                                  ],
                                  className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                                }) : JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: Util.ReactStuff.s("Make Prezzee your one stop shop for local New Zealand gift cards. Favourite brands include Farmers, David Jones, JB HiFi and more.")
                                        }),
                                    JsxRuntime.jsx("a", {
                                          children: JsxRuntime.jsx("button", {
                                                children: Util.ReactStuff.s("Buy NZ gift cards"),
                                                className: Cn.make([
                                                      Button.primaryStyle,
                                                      "h-12 w-56 mt-6"
                                                    ])
                                              }),
                                          href: "/store/"
                                        })
                                  ],
                                  className: "my-16 w-11/12 sm:w-9/12 mx-auto"
                                })
                        ]
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Buy USA gift cards"),
                                      className: Cn.make([
                                            Button.primaryStyle,
                                            "h-12 w-56 mt-6 block"
                                          ])
                                    }),
                                href: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* UnitedStates */2
                                    }) ? "/store/" : (
                                    isStg ? List.assoc("us", stgDomains) : List.assoc("us", prodDomains)
                                  ),
                                target: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* UnitedStates */2
                                    }) ? "_self" : "_blank"
                              }),
                          JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Buy CA gift cards"),
                                      className: Cn.make([
                                            Button.primaryStyle,
                                            "h-12 w-56 mt-6 block"
                                          ])
                                    }),
                                href: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* Canada */4
                                    }) ? "/store/" : (
                                    isStg ? List.assoc("ca", stgDomains) : List.assoc("ca", prodDomains)
                                  ),
                                target: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* Canada */4
                                    }) ? "_self" : "_blank"
                              }),
                          JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Buy UK gift cards"),
                                      className: Cn.make([
                                            Button.primaryStyle,
                                            "h-12 w-56 mt-6 block"
                                          ])
                                    }),
                                href: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* GreatBritain */1
                                    }) ? "/store/" : (
                                    isStg ? List.assoc("uk", stgDomains) : List.assoc("uk", prodDomains)
                                  ),
                                target: Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                      TAG: /* Ok */0,
                                      _0: /* GreatBritain */1
                                    }) ? "_self" : "_blank"
                              }),
                          JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Buy Aussie gift cards"),
                                      className: Cn.make([
                                            Button.primaryStyle,
                                            "h-12 w-56 mt-6 block"
                                          ])
                                    }),
                                href: isStg ? List.assoc("au", stgDomains) : List.assoc("au", prodDomains),
                                target: "_blank"
                              }),
                          JsxRuntime.jsx("a", {
                                children: JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Buy NZ gift cards"),
                                      className: Cn.make([
                                            Button.primaryStyle,
                                            "h-12 w-56 mt-6 block"
                                          ])
                                    }),
                                href: isStg ? List.assoc("nz", stgDomains) : List.assoc("nz", prodDomains),
                                target: "_blank"
                              })
                        ],
                        className: "my-10 flex flex-wrap justify-between"
                      })
              ]
            });
}

var Link;

var make = InternationalContentMobile;

export {
  Link ,
  prodDomains ,
  stgDomains ,
  isStg ,
  make ,
}
/* isStg Not a pure module */
